import type { InferInsertModel, InferSelectModel } from 'drizzle-orm';
import { pgTable, text, timestamp, unique, uuid } from 'drizzle-orm/pg-core';
import { userRoleEnum } from './users';

/**
 * Complemento dinâmico do `ac`/`roles` estático do better-auth (src/lib/permissions.ts).
 * Recursos compilados (users, auth, dashboard) continuam no `ac` estático; recursos
 * criados via editor de screens usam esta tabela + o cache em memória (src/lib/permission-cache.ts).
 */
export const dynamicPermissions = pgTable(
  'dynamic_permissions',
  {
    id: uuid('id')
      .primaryKey()
      .$defaultFn(() => Bun.randomUUIDv7()),
    resource: text('resource').notNull(),
    action: text('action').notNull(),
    role: userRoleEnum('role').notNull(),
    createdAt: timestamp('created_at')
      .notNull()
      .$defaultFn(() => new Date()),
  },
  (t) => [unique().on(t.resource, t.action, t.role)],
);

export type DynamicPermission = InferSelectModel<typeof dynamicPermissions>;
export type CreateDynamicPermissionInput = InferInsertModel<typeof dynamicPermissions>;
